import React from 'react';
import { Route, Redirect } from 'react-router-dom';

export const PrivateRoute = ({ component: Component, role, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      if (role && role !== 'TENANT_ADMIN') {
        return <Redirect to={{ pathname: '/404' }} />;
      }

      return <Component {...props} />;
    }}
  />
);
